<template>
  <CFooter :fixed="false">
    <div>
      <a href="http://ees.com.vn" target="_blank">Enterprise Energy Solution</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="http://ees.com.vn">Software team</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
